// packages/domain/src/enums/RecipeType.ts
export enum RecipeType {
  Breakfast = 'Breakfast',
  Lunch = 'Lunch',
  Dinner = 'Dinner',
  Snack = 'Snack',
}

export const VALID_RECIPE_TYPES = new Set<string>(Object.values(RecipeType));
